<template>
  <v-container fluid :class="{ 'modal-container': isInModal, 'container-full-bg-gray': !isInModal }">
    <CreationObject 
      :objectType="objectType" 
      objectName="Proveedor" 
      :url="url" 
      :id="supplier" 
      :is-in-modal="isInModal"
      :is-header-fixed="isInModal ? true : false"
      :third-name="cru_name"
      :third-cif="cru_cif"
      :document_id="document_id"
      @createdObject="mycreated" 
      :company_nif="nif"
      :company_name="name"
      @updateParams="$emit('updateParams')"
      :areParamsChanged="areParamsChanged"
      @cancel="$emit('cancel')"
      :hideSaveBtn="got_feature('feature_not_create_thirds_and_masters')"
    >
      <template #tabs-title>
        <div class="px-8 pt-2 tabs-title-div-bck">
          <v-row align="center">
            <v-col cols="12" class="pt-0">
              <v-tabs v-model="currentTab">
                <v-tab key="data">Datos</v-tab>
                <v-tab key="parameters">Parámetros</v-tab>
              </v-tabs>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:inputs v-if="currentCompany">
        <app-row  v-if="Object.keys(cru_errors_supplierScreenValues).length">
          <v-expand-transition>
            <app-col cols="12" class="pt-8" v-show="Object.keys(cru_errors_supplierScreenValues).length">
              <v-alert
                outlined
                prominent
                text
                type="error"
              >
                <div v-for="error in cru_errors_supplierScreenValues" :key="error.toString()">
                  <div v-if="Array.isArray(error)">{{firstAppearance(error)}}</div>
                  <div v-else>{{error}}</div>
                </div> 
              </v-alert>
            </app-col>
          </v-expand-transition>
        </app-row>
        <v-tabs-items class="ma-0 pa-0" v-model="currentTab">
          <v-tab-item class="ma-0 pa-0" key="data">
            <app-row class="pt-0 mt-0" v-if="got_feature('feature_generic_thirds')">
              <v-col cols="12" sm="6" md="4" class="col-check-btn">                     
                <v-checkbox 
                  autocomplete="off"
                  :label="cru_label_is_generic" 
                  v-model="cru_is_generic"
                  :readonly="['glasof', 'glasof_autonomos'].indexOf(currentCompany.companydb_type.value) > -1"  
                  @change="change_boolean('is_generic')"   
                  class="my-2 ml-2"
                  style="display: inline-block;"
                  :hide-details="true"
                >
                </v-checkbox> 

                <v-tooltip right v-if="['glasof', 'glasof_autonomos'].indexOf(currentCompany.companydb_type.value) > -1">
                  <template v-slot:activator="{ on, attrs }">                
                    <v-btn 
                      v-bind="attrs"
                      v-on="on"
                      icon 
                      color="primary"
                      >
                      <v-icon>mdi-information-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>Campo configurable desde Glasof, marcar "Pedir Nif en apuntes"</span>
                </v-tooltip>
              </v-col>
            </app-row>
            <app-row class="pt-0 mt-0" v-if="got_feature('feature_can_user_company_data')">
              <app-col cols="12" lg="4">
                <app-btn
                  color="primary"
                  class="btn-save"
                  :disabled="cru_cif===''"
                  @click="autocompleteSupplierData()"
                >
                  Autocompletar
                </app-btn>
                <message-popup 
                  title="Aviso"
                  :show_message="showAutocompletePupup"  
                  :message="`<p>¿Está seguro que quiere modificar los campos con los siguientes datos?</p>
                            <ul>
                              <li>CIF: ${company_data && company_data['cif']}</li>
                              <li>Nombre: ${company_data && company_data['name']}</li>
                              <li>Nombre comercial: ${company_data && company_data['comercial_names']}</li>
                              <li>Dirección: ${company_data && company_data['address']}</li>
                              <li>CP: ${company_data && company_data['zip_code']}</li>
                              <li>Ciudad: ${company_data && company_data['city']}</li>
                              <li>Provincia: ${company_data && company_data['province']}</li>
                              <li>Pais: ${company_data && company_data['country']}</li>
                              <li>Email: ${company_data && company_data['email']}</li>
                              <li>Teléfono: ${company_data && company_data['phones']}</li>
                              <li>Website: ${company_data && company_data['websites']}</li>
                            </ul>`"
                  :actions="[{ 'action_text': 'Cancelar', 'emit': 'close-message' }, { 'action_text': 'Aceptar', 'emit': 'confirm-update-data', 'prin': true }]"
                  @close-message="confirmCompanyData(false)" 
                  @confirm-update-data="confirmCompanyData(true)"
                ></message-popup>
                <message-popup 
                  title="Aviso"
                  :show_message="showDataNotFoundMessage"  
                  :message="`<p>No se ha encontrado ninguna referencia al CIF indicado</p>
                            <p>CIF : ${cru_cif}</p>`"
                  :actions="[{ 'action_text': 'Aceptar', 'emit': 'close-message','prin': true },]"
                  @close-message="showDataNotFoundMessage = false" 
                ></message-popup>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12" lg="4">
                <app-doc-text-field 
                  v-model="cru_cif"
                  kind="text"
                  :label="cru_label_cif" 
                  :error="Boolean(cru_error_cif)"
                  :error-messages="cru_error_cif"
                  @input="check_duplicates"
                ></app-doc-text-field>
                <div style="margin-top:-28px;color:#f34336">
                {{duplicate_message}}
                </div>
              </app-col>
              <app-col contains-input-fields cols="12" lg="4" :has-input-fields-above="$vuetify.breakpoint.mdAndDown" >
                <app-doc-text-field 
                  kind="text"
                  v-model="cru_name"
                  append-icon="mdi-format-letter-case-upper"
                  append-icon-tooltip-text="Transformar texto a mayúsculas"
                  :label="cru_label_name" 
                  :error="Boolean(cru_error_name)"
                  :error-messages="cru_error_name"
                  @click:append="upper()"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields cols="12" lg="4" :has-input-fields-above="$vuetify.breakpoint.mdAndDown" >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on">
                      <app-doc-text-field 
                        v-model="cru_reference"
                        kind="text"
                        :disabled="!feature_supplier_reference"
                        :label="cru_label_reference" 
                        :error="Boolean(cru_error_reference)"
                        :error-message="cru_error_reference"
                      ></app-doc-text-field>
                    </div>
                  </template>
                  <span>Asignará a este proveedor los documentos que contengan esta referencia</span>
                </v-tooltip> 
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col has-input-fields-above contains-input-fields cols="12" lg="4" class="d-flex flex-sm-nowrap align-baseline">
                <app-autocomplete
                  autocomplete="off"
                  :label="cru_label_type"  
                  v-model="cru_type"
                  :items="thirdTypeTypes"
                  :readonly="false"
                  :error="Boolean(cru_error_type)"
                  :error-messages="cru_error_type"
                  class="flex-grow-1"
                >
              </app-autocomplete>
              <v-tooltip top v-if="cru_type && (cru_type == 'fisica' || (hasEInvoiceContract && cru_type == 'juridica'))">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    @click="showAdditionalInfo = true"
                    v-bind="attrs"
                    v-on="on"
                    icon 
                    color="primary"
                    >
                    <v-icon>mdi-information-variant</v-icon>
                  </v-btn>
                </template>
                <span>Datos ampliados</span>
              </v-tooltip>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" :lg="feature_account_type_innuva && !supplier ? 8 : 4">
                <app-doc-text-field 
                  v-if="currentCompany.companydb_type.value!='reviso'"
                  kind="account"
                  third="supplier"
                  :label="cru_label_credit_account"  
                  v-model="cru_credit_account"
                  :error="Boolean(cru_error_credit_account)"
                  :readonly="supplier"
                  :num_digits="currentCompany.companydb_type.params && (currentCompany.companydb_type.params.hasOwnProperty('accounts_length') || currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length')) ? false : currentCompany.num_digits"
                  :enable_account_types="feature_account_type_innuva && !supplier"
                  :account_types="account_types"
                  @input="onAccountChange"
                />
                <app-autocomplete
                  v-else
                  :label="cru_label_supplier_group"
                  v-model="cru_supplier_group"
                  :items="group_accounts_in_reviso"
                  :disabled="group_accounts_in_reviso.length < 1"
                  :error="Boolean(cru_error_supplier_group)"
                  :error-messages="cru_error_supplier_group"
                  @change="onRevisoGroupChange"
                />
                <AccountPrefixValidator 
                  :account-value="currentText" 
                  :enabled-groups="currentCompany.companydb_type.type == 'account_move' ? ['43','44'] : []"
                /> <!-- For invoice type companies, supplier account prefix check not necessary -->
              </app-col>
              <app-col
                v-if="currentCompany.companydb_type.value == 'reviso'"
                contains-input-fields has-input-fields-above cols="12" :lg="4"
              >
                <app-doc-text-field
                  kind="account"
                  :label="cru_label_credit_account"  
                  v-model="cru_credit_account"
                  :readonly="true"
                  :error="Boolean(cru_error_credit_account)"
                  :error-messages="cru_error_credit_account"
                />
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  v-model="cru_alias"
                  kind="text"
                  :label="cru_label_alias" 
                  :error="Boolean(cru_error_alias)"
                  :error-messages="cru_error_alias"
                  :append-icon="!!name? 'mdi-lightbulb' : ''"
                  :append-icon-tooltip-text="!!name ? 'Obtener Nombre Comercial detectado en la factura' : ''"
                  @click:append="cru_alias = name" 
                ></app-doc-text-field>
              </app-col>
              <app-col 
                contains-input-fields has-input-fields-above cols="12" lg="4"
                v-if="got_feature('feature_identity_key')"
              >
                <app-autocomplete
                  autocomplete="off"
                  :label="cru_label_identity_key"  
                  v-model="cru_identity_key"
                  :items="identity_keys"
                  :readonly="false"  
                  class="autocomplete-input"
                  :error="Boolean(cru_error_identity_key)"
                  :error-messages="cru_error_identity_key"
                ></app-autocomplete>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_address" 
                  v-model="cru_address"
                  :error="Boolean(cru_error_address)"
                  :error-messages="cru_error_address"
                ></app-doc-text-field>
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_zip_code"  
                  v-model="cru_zip_code"
                  :error="Boolean(cru_error_zip_code)"
                  :error-messages="cru_error_zip_code"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_city" 
                  v-model="cru_city"
                  :error="Boolean(cru_error_city)"
                  :error-messages="cru_error_city"
                ></app-doc-text-field>
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_province" 
                  v-model="cru_province"
                  :error="Boolean(cru_error_province)"
                  :error-messages="cru_error_province"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-autocomplete
                  autocomplete="off"
                  :label="cru_label_country" 
                  v-model="cru_country"
                  :items="autocompleteCountryItems"
                  class="autocomplete-input pa-0"
                  :error="Boolean(cru_error_country)"
                  :error-messages="cru_error_country"
                ></app-autocomplete>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_email" 
                  v-model="cru_email"
                  :error="Boolean(cru_error_email)"
                  :error-messages="cru_error_email"
                ></app-doc-text-field>
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_phone" 
                  v-model="cru_phone"
                  :error="Boolean(cru_error_phone)"
                  :error-messages="cru_error_phone"
                ></app-doc-text-field>
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_website" 
                  v-model="cru_website"
                  :error="Boolean(cru_error_website)"
                  :error-messages="cru_error_website"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="8">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_notes" 
                  v-model="cru_notes"
                  :error="Boolean(cru_error_notes)"
                  :error-messages="cru_error_notes"
                ></app-doc-text-field>
              </app-col>
            </app-row>
          </v-tab-item>
          <v-tab-item class="ma-0 pa-0" key="parameters">
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12" lg="4">
                <!-- esta dando un warning pq componente espera string o null y esto es una lista -->
                <app-doc-text-field
                  :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                  :label="cru_label_expens_accounts"
                  v-model="cru_expens_accounts"
                  :error="Boolean(cru_error_expens_accounts)"
                  :error-messages="cru_error_expens_accounts"
                  :is_array="true"
                  :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                  :num_digits="currentCompany.companydb_type.params && (currentCompany.companydb_type.params.hasOwnProperty('accounts_length') || currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length')) ? false : currentCompany.num_digits"
                  :items="got_feature('feature_accounts_master') ? accounts : []"
                  :account_prefix_filter="
                    currentCompany.companydb_type.value === 'aplifisa_fiscal' ? '6' :
                    (['estimasol', 'estimasol_nube'].includes(currentCompany.companydb_type.value) && !got_feature('feature_disable_validation_accounts_format')) ? 'G' :
                    ''"
                  @get-values="getValues"
                  @reset-items="resetItems"
                  @input="onAccountChange"
                />

                <AccountPrefixValidator 
                  :account-value="currentText" 
                  :enabled-groups="['7']" 
                />

              </app-col>
            </app-row>
            <app-row contains-input-fields :style="refAccountsStyle" v-if="showRefAccountDetailLocal" >
              <app-col contains-input-fields cols="12" lg="6">
                <DetailReferenceAccounts
                    :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                    :accounts="cru_ref_expens_accounts"
                    :error="errorInRefAccounts"
                    @update="updateRefExpensAccounts"
                    :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                    :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                    :items="got_feature('feature_accounts_master') ? accounts : []"
                    :account_prefix_filter="['estimasol', 'estimasol_nube', 'aplifisa_fiscal'].includes(currentCompany.companydb_type.value) && !got_feature('feature_disable_validation_accounts_format') ? 'G' : ''"
                    @get-values="getValues"
                    @reset-items="resetItems"
                    ></DetailReferenceAccounts>
              </app-col>
            </app-row>
            <app-row contains-input-fields v-if="got_feature('feature_can_see_table_payment_methods')">
              <app-col  contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4" >
                <!-- :disabled="!feature_payment_move" -->
                <app-autocomplete
                  v-model="cru_automatic_payment_account"
                  :label="cru_label_automatic_payment_account"  
                  :items="automaticPaymentAccountTypes"
                  class="autocomplete-input"
                  :error="Boolean(cru_error_automatic_payment_account)"
                  :error-messages="cru_error_automatic_payment_account"
                  :disabled="isDisabledAutomaticPayment()"
                  @change="onAutomaticPaymentChange"
                ></app-autocomplete> 
              </app-col>
              <app-col  contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4" >
                <app-autocomplete
                  autocomplete="off"
                  :disabled="isDisabledPaymentMethod()"
                  :label="cru_label_cartera"
                  v-model="cru_payment_method_id"
                  :items="payment_methods"
                  itemText="name"
                  itemValue="payment_method_id"
                  class="autocomplete-input"
                  :error="Boolean(cru_error_cartera)"
                  :error-messages="cru_error_cartera"
                  @change="onPaymentMethodChange"
                />
              </app-col>
              <app-col  contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4">
                <app-doc-text-field dense
                  kind="account"
                  :disabled="isDisabledPaymentMethod()"
                  v-model="cru_payment_account"
                  :label="cru_label_payment_account"
                  hint="Únicamente aplica cuando la opción 'Sí' está activa"
                  :error="Boolean(cru_error_payment_account)"
                  :error-messages="cru_error_payment_account"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                  />
              </app-col>
            </app-row>
            <app-row contains-input-fields v-else>
              <app-col  contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4" >
                <app-autocomplete
                  autocomplete="off"
                  :disabled="!feature_payment_move"
                  :label="cru_label_automatic_payment_account"  
                  v-model="cru_automatic_payment_account"
                  :items="automaticPaymentAccountTypes"
                  :readonly="false"  
                  class="autocomplete-input"
                  :error="Boolean(cru_error_automatic_payment_account)"
                  :error-messages="cru_error_automatic_payment_account"
                ></app-autocomplete> 
              </app-col>
              <app-col  contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4">
                <app-doc-text-field dense
                  kind="account"
                  :disabled="!feature_payment_move || (cru_automatic_payment_account && cru_automatic_payment_account != 'y')"
                  v-model="cru_payment_account"
                  :label="cru_label_payment_account"
                  hint="Únicamente aplica cuando la opción 'Sí' está activa"
                  :error="Boolean(cru_error_payment_account)"
                  :error-messages="cru_error_payment_account"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                  />
              </app-col>
            </app-row>

            <!-- <app-row contains-input-fields :style="refAccountsStyle" v-if="showRefAccountDetailLocal" >
              <app-col contains-input-fields cols="12" lg="6">
                <DetailReferenceAccounts
                    :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                    :accounts="cru_ref_expens_accounts"
                    :error="errorInRefAccounts"
                    @update="updateRefExpensAccounts"
                    :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                    :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                    :items="got_feature('feature_accounts_master') ? accounts : []"
                    :account_prefix_filter="
                      currentCompany.companydb_type.value === 'aplifisa_fiscal' ? '6' :
                      (['estimasol', 'estimasol_nube'].includes(currentCompany.companydb_type.value) && !got_feature('feature_disable_validation_accounts_format')) ? 'G' :
                      ''"
                    @get-values="getValues"
                    @reset-items="resetItems"
                    ></DetailReferenceAccounts>
              </app-col>
            </app-row> -->
            <app-row contains-input-fields>
              <!-- Cuenta de Pago / Cobros -->
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4" >
                <app-autocomplete
                  v-model="cru_retention_type"
                  autocomplete="off"
                  :label="cru_label_retention_type"  
                  :items="filtered_retention_types"
                  :readonly="false"  
                  class="autocomplete-input pa-0"
                  :error="Boolean(cru_error_retention_type)"
                  :error-messages="cru_error_retention_type"
                />
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4"  v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_expense_income_type">
                <app-autocomplete
                    outlined
                    :clearable="true"
                    autocomplete="off"
                    :label="cru_label_expens_income_type"
                    v-model="cru_default_expens_income_type"
                    :items="getExpensType"
                    item-text="name"
                    item-value="eit_id"
                    :readonly="false"
                    class="autocomplete-input pa-0"

                ></app-autocomplete>
              </app-col>
              <app-col 
                contains-input-fields 
                has-input-fields-above
                cols="12" lg="4"
                v-if="feature_cadastral_reference && cru_retention_type=='retention_rental_account'"
              >
                 <app-doc-text-field 
                   kind="string"
                   v-model="cru_cadastral_reference"
                   :label="cru_label_cadastral_reference"
                 />
              </app-col>
              <app-col 
                cols="12" lg="4" 
                contains-input-fields
                has-input-fields-above
                v-if="feature_building_code && currentCompany && currentCompany.companydb_type.params && currentCompany.companydb_type.params['show'] && currentCompany.companydb_type.params['show'].includes('building_code')"
              >
                <app-doc-text-field
                  kind="text"
                  :label="cru_label_building_code"
                  v-model="cru_building_code"
                  @change="areParamsChanged=true"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <!-- Fiscal Location -->
              <app-col v-if="got_feature('feature_assign_fiscal_location')" contains-input-fields has-input-fields-above cols="12" lg="4" >
                <app-autocomplete
                  v-model="cru_fiscal_location"
                  autocomplete="off"
                  :label="cru_label_fiscal_location"
                  :items="fiscal_locations"
                  :readonly="false"  
                  class="autocomplete-input pa-0"
                  :error="Boolean(cru_error_fiscal_location)"
                  :error-messages="cru_error_fiscal_location"
                />
              </app-col>
            </app-row>
            <app-row contains-input-fields >
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" >
                <app-select
                  v-model="cru_decimal_separator"
                  class="autocomplete-input"
                  :disabled="!feature_decimal_separator"
                  
                  :items="decimal_separator_choices"
                  :label="cru_label_decimal_separator"
                />
              </app-col>
              <app-col
                contains-input-fields has-input-fields-above cols="12" lg="4"
                v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_description_sii"
              >
                <app-select
                  v-model="cru_description_sii"
                  outlined
                  :items="[
                    { 'text': 'Descripción Factura', 'value': 'descr_factura' },
                    { 'text': 'Valor Fijo', 'value': 'valor_fijo' }
                  ]"
                  @change="changeDescriptionSII()"     
                  :label="cru_label_description_sii"
                />
              </app-col>
              <app-col 
                contains-input-fields
                has-input-fields-above
                cols="12" lg="4" 
                v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_description_sii"
              >
                <app-doc-text-field 
                  :disabled="cru_description_sii != 'valor_fijo'"
                  kind="text"
                  :label="cru_label_fixed_value" 
                  v-model="cru_fixed_value"
                  :error="Boolean(cru_error_fixed_value)"
                  :error-messages="cru_error_fixed_value"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields >
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-autocomplete
                  v-model="cru_auto_fill_due_date"
                  autocomplete="off"
                  class="autocomplete-input"
                  :label="cru_label_auto_fill_due_date"
                  :disabled="!feature_can_auto_fill_due_date"
                  :items="[{'text': 'N/A', 'value': 'na'}, {'text': 'Si', 'value': 'y'}, {'text': 'No', 'value': 'n'}]"
                  :readonly="false"  
                  :error="Boolean(cru_error_auto_fill_due_date)"
                  :error-messages="cru_error_auto_fill_due_date"
                />
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  kind="number"
                  :disabled="!feature_price_range"
                  :label="cru_label_min_price"
                  v-model="cru_min_price"
                  :error="Boolean(cru_error_min_price)"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  kind="number"
                  :disabled="!feature_price_range"
                  :label="cru_label_max_price"
                  v-model="cru_max_price"
                  :error="Boolean(cru_error_max_price)"
                ></app-doc-text-field>
              </app-col>
              
            </app-row>
            <app-row>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_actividad_selector') && activities.length > 0 && (currentCompany && !currentCompany.hide_activities_master)">
                <app-autocomplete
                  :label="cru_label_default_actividad"
                  v-model="cru_default_actividad"
                  :items="activities"
                  item-value="code"
                  item-text="name"
                  :clearable="true"
                />
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4" v-else-if="currentCompany && !currentCompany.hide_activities_master">
                <app-doc-text-field
                  kind="string"
                  v-model="cru_default_actividad"
                  :label="cru_label_default_actividad"
                  />
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_project_channel_in_third') && got_feature('feature_document_projects') && hasMasterPermission('project') && !currentCompany.hide_projects_master">
                <app-autocomplete
                  :label="cru_label_default_project"
                  v-model="cru_default_project"
                  :items="projects"
                  item-value="id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_project_channel_in_third') && got_feature('feature_channel') && hasMasterPermission('channel') && !currentCompany.hide_channels_master">
                <app-autocomplete
                  :label="cru_label_default_channel"
                  v-model="cru_default_channel"
                  :items="channels"
                  item-value="channel_id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_section_in_third') && got_feature('feature_sections') && hasMasterPermission('section') && !currentCompany.hide_sections_master">
                <app-autocomplete
                  :label="cru_label_default_section"
                  v-model="cru_default_section"
                  :items="sections"
                  item-value="section_id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_delegation_in_third') && got_feature('feature_delegations') && hasMasterPermission('delegation') && !currentCompany.hide_delegations_master">
                <app-autocomplete
                  :label="cru_label_default_delegation"
                  v-model="cru_default_delegation"
                  :items="delegations"
                  item-value="delegation_id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_department_in_third') && got_feature('feature_departments') && hasMasterPermission('department') && !currentCompany.hide_departments_master">
                <app-autocomplete
                  :label="cru_label_default_department"
                  v-model="cru_default_department"
                  :items="departments"
                  item-value="department_id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col 
                contains-input-fields has-input-fields-above cols="12" lg="4" 
                v-if="feature_payment_method && hasMasterPermission('payment_method')"
              >
                <app-text-field
                  v-model="cru_payment_method"
                  autocomplete="off"
                  class="autocomplete-input pa-0"
                  :label="cru_label_payment_method"
                  :error="Boolean(cru_error_payment_method)"
                  :error-messages="cru_error_payment_method"
                />
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  :disabled="!showSuplidoAccount()"
                  autocomplete="off"
                  v-model="cru_suplido_account"
                  :label="cru_label_suplido_account"
                  kind="account"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  v-if="got_feature('feature_retention_accounts_supplier')"
                  autocomplete="off"
                  v-model="cru_retention_professional_account"
                  :label="cru_label_retention_professional_account"
                  kind="account"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                ></app-doc-text-field>
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  v-if="got_feature('feature_retention_accounts_supplier')"
                  autocomplete="off"
                  v-model="cru_retention_rental_account"
                  :label="cru_label_retention_rental_account"
                  kind="account"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                ></app-doc-text-field>
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  v-if="got_feature('feature_retention_accounts_transport')"
                  autocomplete="off"
                  v-model="cru_retention_transport_account"
                  :label="cru_label_retention_transport_account"
                  kind="account"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-select
                  v-model="cru_cut_inv_num"
                  :items="[
                    {'text': 'N/A', 'value': ''},
                    {'text': 'Mantener todos los caracteres', 'value': 'no_cut'},
                    {'text': 'Mantener los primeros caracteres', 'value': 'cut_first'},
                    {'text': 'Mantener los últimos caracteres', 'value': 'cut_last'}
                  ]"
                  :label="cru_label_cut_inv_num"
                />
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-text-field
                  :disabled="!(cru_cut_inv_num && cru_cut_inv_num != 'no_cut')"
                  v-model="cru_num_chars_inv_num"
                  :label="cru_label_num_chars_inv_num"
                  autocomplete="off"
                  :error="Boolean(cru_error_num_chars_inv_num)"
                  :error-messages="cru_error_num_chars_inv_num"
                />
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-select
                  autocomplete="off"
                  :disabled="!(cru_cut_inv_num && cru_cut_inv_num != 'no_cut')"
                  :label="cru_label_chars_to_exclude"
                  v-model="cru_chars_to_exclude"
                  :items="[{'name':'Guión','value':'-'},
                    {'name':'Punto','value':'.'},
                    {'name':'Coma','value':','},
                    {'name':'Dos puntos','value':':'},
                    {'name':'Punto y coma','value':';'},
                    {'name': 'Barra', 'value': '/'},
                    {'name': 'Contrabarra', 'value': '\\'},
                    {'name': 'Almohadilla', 'value': '#'},
                    {'name':'Letras','value':'letters'},
                    {'name':'Espacio en blanco','value':'whitespace'}]"
                  item-text="name"
                  item-value="value"
                  multiple
                  clearable
                />
              </app-col>
            </app-row>
            <app-row  contains-input-fields>
              <app-col 
                contains-input-fields has-input-fields-above cols="12" lg="4"
                v-if="feature_bien_inversion && !hideBienInversionAccount && (isNotDesgloseDeCuentas() || isRegularSupplierAccountType)"
              >
                <app-doc-text-field
                  kind="account"
                  v-model="cru_expens_account_bien_inversion"
                  :label="cru_label_expens_account_bien_inversion"
                  :error="Boolean(cru_error_expens_account_bien_inversion)"
                  :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                  :num_digits="currentCompany.companydb_type.params && (currentCompany.companydb_type.params.hasOwnProperty('accounts_length') || currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length')) ? false : currentCompany.num_digits"
                />
              </app-col>
              <template v-if="got_feature('feature_serie_in_docs')">
                <app-col 
                  contains-input-fields has-input-fields-above cols="12" lg="4"
                >
                  <v-checkbox
                    :label="cru_label_have_serie"
                    v-model="cru_have_serie"
                  ></v-checkbox>
                </app-col>
                <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                  <app-combobox
                    :disabled="!cru_have_serie"
                    :label="cru_label_series"
                    :items="[]"
                    multiple
                    small-chips
                    v-model="cru_series"
                  />
                </app-col>
              </template>
            </app-row>
            <app-row contains-input-fields v-if="got_feature('feature_other_documents') && cru_data">
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" >
                  <app-select v-model="cru_data['after_done_wf']" label="Workflow post-contabilización" item-value="id" item-text="name"
                  :items="workflowOptions" outlined
                  name="selectorWorkflow"
                ></app-select>
              </app-col>
            </app-row>

            <app-row contains-input-fields>
              <app-col 
                contains-input-fields 
                has-input-fields-above 
                class="checkbox-col"
              >
                <v-checkbox
                  v-if="got_feature('feature_ignore_cif_validation')"
                  :label="cru_label_ignore_cif_validation"
                  v-model="cru_ignore_cif_validation"
                />

                <v-checkbox
                  v-if="got_feature('feature_third_auto_accounting')"
                  v-model="toggleAutoAccount"
                  :label="cru_label_auto_account"
                />
              </app-col>
            </app-row>

            <app-row>
              <app-col has-input-fields-above cols="12" lg="6">
                <app-creation-object-section-card>
                  <template #title>
                    <span class="mx-4">Posición fiscal</span>
                  </template>
                  <v-container>
                    <v-row class="ma-0 pa-0">
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_inversion_sujeto_pasivo_iva" 
                          v-model="cru_inversion_sujeto_pasivo_iva"
                          :readonly="false"  
                          @change="change_boolean('inversion_sujeto_pasivo_iva')"   
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_inversion_sujeto_pasivo_igic" 
                          v-model="cru_inversion_sujeto_pasivo_igic"
                          :readonly="false"
                          @change="change_boolean('inversion_sujeto_pasivo_igic')"       
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_intracomunitario"  
                          v-model="cru_intracomunitario"
                          :readonly="false"    
                          @change="change_boolean('intracomunitario')"  
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0" v-if="got_feature('feature_extra_supplier')">
                        <v-checkbox
                          autocomplete="off"
                          :label="cru_label_extracomunitario"
                          v-model="cru_extracomunitario"
                          :readonly="false"
                          @change="change_boolean('extracomunitario')"
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12" sm="6" md="4" class="ma-0 pa-0"
                        v-if="got_feature('feature_supplier_comerciante_minorista') && currentCompany.tax_type == 'igic'"
                      >
                        <v-checkbox
                          autocomplete="off"
                          :label="cru_label_is_comerciante_minorista" 
                          v-model="cru_is_comerciante_minorista"
                          @change="change_boolean('is_comerciante_minorista')"
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0" v-if="feature_no_sujeta || got_feature('feature_exenta_no_sujeta')"> 
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_no_sujeta"
                          v-model="cru_no_sujeta"
                          :readonly="false"
                          @change="change_boolean('no_sujeta')"
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          :disabled="!got_feature('feature_exenta_no_sujeta')"
                          autocomplete="off"
                          :label="cru_label_dry_0_percent" 
                          v-model="cru_dry_0_percent"
                          @change="change_boolean('dry_0_percent')"
                          :readonly="false"  
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col 
                        cols="12" sm="6" md="4" class="ma-0 pa-0"
                        v-if="feature_criterio_de_caja"
                      >
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_criterio_de_caja" 
                          v-model="cru_criterio_de_caja"
                          :readonly="false"
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row v-if="feature_no_sujeta && feature_no_sujeta_reference && !cru_no_sujeta" style="margin-top:-2vh" class="ma-0 pa-0">
                      <v-col class="ma-0 pa-0" cols="12">
                        <DetailReferenceSimple :ref_list="cru_refs_no_sujeta" @update="updateRefNoSujeta" ></DetailReferenceSimple> 
                      </v-col>
                    </v-row>
                    <v-row class="ma-0 pa-0 mt-4">
                      <v-col class="pa-0 ma-0 pr-4" cols="12" lg="4" v-if="cru_inversion_sujeto_pasivo_iva">
                        <app-autocomplete
                          autocomplete="off"
                          :label="cru_label_percent" 
                          v-model="cru_inversion_sujeto_pasivo_iva_percent"
                          :items="iva_values"
                          :readonly="false"  
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                          :background-color="Boolean(cru_error_inversion_sujeto_pasivo_iva_percent)?'#ff9898':'#ffffff'"
                        />
                      </v-col>
                      <v-col class="pa-0 ma-0 pr-4" cols="12" lg="4" v-if="cru_inversion_sujeto_pasivo_igic">
                        <app-autocomplete
                          autocomplete="off" 
                          :label="cru_label_percent"  
                          v-model="cru_inversion_sujeto_pasivo_igic_percent"
                          :items="igic_values"
                          :readonly="false"  
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                          :background-color="Boolean(cru_error_inversion_sujeto_pasivo_igic_percent)?'#ff9898':'#ffffff'"
                        />
                      </v-col>
                      <v-col class="pa-0 ma-0 pr-4" cols="12" lg="4" v-if="cru_intracomunitario && feature_intra_type">
                        <app-autocomplete
                          autocomplete="off"
                          :label="cru_label_intracomunitario_type"
                          v-model="cru_intracomunitario_type"
                          :items="[{text: 'Bienes', value: 'bienes'}, {text: 'Servicios', value: 'servicios'}]"
                          :readonly="false"
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                          :background-color="Boolean(cru_error_intracomunitario_type)?'#ff9898':'#ffffff'"
                        />
                      </v-col>
                      <v-col class="pa-0 ma-0 pr-4" cols="12" lg="4" v-if="cru_extracomunitario && (feature_extra_type || feature_extracomunitario_type)">
                        <app-autocomplete
                          autocomplete="off"
                          :label="cru_label_extracomunitario_type"
                          v-model="cru_extracomunitario_type"
                          :items="[{text: 'Bienes', value: 'bienes'}, {text: 'Servicios', value: 'servicios'}]"
                          :readonly="false"
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                          :background-color="Boolean(cru_error_extracomunitario_type)?'#ff9898':'#ffffff'"
                        />
                      </v-col>
                      <v-col class="pa-0 ma-0 pr-4" cols="12" lg="4" v-if="cru_extracomunitario && feature_extracomunitario_percent">
                        <app-autocomplete
                          autocomplete="off"
                          :label="cru_label_percent"
                          v-model="cru_importaciones_percent"
                          :items="intra_values"
                          :readonly="false"
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                          :background-color="Boolean(cru_error_importaciones_percent)?'#ff9898':'#ffffff'"
                        />
                      </v-col>
                      <v-col class="pa-0 ma-0 pr-4" cols="12" lg="4" v-if="cru_intracomunitario">
                        <app-autocomplete
                          autocomplete="off"
                          :label="cru_label_percent"
                          v-model="cru_intracomunitario_percent"
                          :items="intra_values"
                          :readonly="false"  
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                          :background-color="Boolean(cru_error_intracomunitario_percent)?'#ff9898':'#ffffff'"
                        />
                      </v-col>
                      <v-col class="pa-0 ma-0 pr-4" cols="12" lg="4" v-if="cru_is_comerciante_minorista">
                        <app-autocomplete
                          autocomplete="off" 
                          :label="cru_label_percent"  
                          v-model="cru_is_comerciante_minorista_percent"
                          :items="igic_values"
                          :readonly="false"  
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                          :background-color="Boolean(cru_is_comerciante_minorista_percent)?'#ff9898':'#ffffff'"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </app-creation-object-section-card>
              </app-col>
              <app-col has-input-fields-above cols="12" lg="6">
                <app-creation-object-section-card>
                  <template #title>
                    <span class="mx-4">Deducibilidad</span>
                  </template>
                  <v-container>
                    <v-radio-group hide-details class="ma-0 pa-0" v-model="selectedIvaCheck" :mandatory="false" @change="areIvaChecksChanged=true">
                      <v-row class="ma-0 pa-0" align="center">
                        <v-col class="pa-0 ma-0 my-2" cols="12" lg="6" @click="toggleIvaCheck">
                          <v-radio value="iva_igic_no_deducible" :label="cru_label_iva_igic_no_deducible" />
                        </v-col>
                        <v-col class="pa-0 ma-0 my-2" cols="12" lg="6" @click="toggleIvaCheck" v-if="feature_gasto_iva_parcial">
                          <v-radio value="gasto_iva_parcial" :label="cru_label_gasto_iva_parcial" />
                        </v-col>
                        <v-col class="pa-0 ma-0 my-2" cols="12" lg="6" @click="toggleIvaCheck" v-if="feature_iva_deducible_parcialmente">
                          <v-radio value="iva_parcial" :label="cru_label_iva_parcial" />
                        </v-col>
                        <v-col class="pa-0 ma-0 my-2" cols="12" lg="6" @click="toggleIvaCheck" v-if="feature_prorate && currentCompany.prorate">
                          <v-radio value="prorate" :label="cru_label_prorate" />
                        </v-col>
                      </v-row>
                    </v-radio-group>
                    <v-row class="ma-0 pa-0 mt-4" v-if="got_feature('feature_no_deducible_accounts') && selectedIvaCheck=='gasto_iva_parcial'">
                      <v-col class="ma-0 pa-0 pr-4" cols="12" lg="6">
                        <app-doc-text-field
                          kind="account"
                          v-model="cru_gasto_no_deducible_account"
                          :label="cru_label_gasto_no_deducible_account"
                          :error="Boolean(cru_error_gasto_no_deducible_account)"
                          :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                          :num_digits="currentCompany.companydb_type.params && (currentCompany.companydb_type.params.hasOwnProperty('accounts_length') || currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length')) ? false : currentCompany.num_digits"
                        />
                      </v-col>
                      <v-col class="ma-0 pa-0 pr-4" cols="12" lg="6">
                        <app-doc-text-field                          
                          kind="account"
                          v-model="cru_iva_no_deducible_account"
                          :label="cru_label_iva_no_deducible_account"
                          :error="Boolean(cru_error_iva_no_deducible_account)"
                          :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                          :num_digits="currentCompany.companydb_type.params && (currentCompany.companydb_type.params.hasOwnProperty('accounts_length') || currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length')) ? false : currentCompany.num_digits"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="ma-0 pa-0 mt-4">
                      <v-col class="ma-0 pa-0 pr-4" cols="12" lg="6" v-if="selectedIvaCheck=='gasto_iva_parcial' || selectedIvaCheck=='iva_parcial'">
                        <app-doc-text-field
                          kind="number"
                          :label="cru_label_gasto_iva_percent"
                          v-model="cru_gasto_iva_percent"
                          :error="Boolean(cru_error_gasto_iva_percent)"
                          @change="areIvaChecksChanged=true"
                        ></app-doc-text-field>
                      </v-col>
                      <v-col class="ma-0 pa-0 pr-4" cols="12" lg="6" v-if="got_feature('feature_exc_expense_account') && selectedIvaCheck=='iva_parcial'">
                        <app-doc-text-field
                          kind="account"
                          v-model="cru_exc_expense_account"
                          :label="cru_label_exc_expense_account"
                          :error="Boolean(cru_error_exc_expense_account)"
                          :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                          :num_digits="currentCompany.companydb_type.params && (currentCompany.companydb_type.params.hasOwnProperty('accounts_length') || currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length')) ? false : currentCompany.num_digits"
                        />
                      </v-col>
                      <v-col class="ma-0 pa-0 pr-4" cols="12" lg="6" v-if="selectedIvaCheck=='iva_igic_no_deducible' && got_feature('feature_comerciante_minorista') && currentCompany.companydb_type.params && ((!currentCompany.companydb_type.params.hasOwnProperty('hide')) || (currentCompany.companydb_type.params.hide && !currentCompany.companydb_type.params.hide.includes('comerciante_minorista')))">
                        <v-checkbox
                            autocomplete="off"
                            :label="cru_label_register_iva_igic_0"
                            v-model="cru_register_iva_igic_0"
                            :readonly="false"
                            class="pa-0 ma-0 my-2"
                            :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>       
                </app-creation-object-section-card>
              </app-col>
            </app-row>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </CreationObject>
    <v-dialog v-model="showAdditionalInfo" persistent max-width="800">
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Datos ampliados</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <template v-if="cru_type=='fisica'">
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12">
                <app-text-field
                  label="Nombre"
                  type="text"
                  v-model="cru_first_name"
                >
                </app-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12">
                <app-text-field
                  label="Primer Apellido"
                  type="text"
                  v-model="cru_first_surname"
                >
                </app-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12">
                <app-text-field
                  label="Segundo Apellido"
                  type="text"
                  v-model="cru_second_surname"
                >
                </app-text-field>
              </app-col>
            </app-row>
          </template>
          <template v-if="cru_type=='juridica'">
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_alias"
                  type="text"
                  v-model="cru_alias"
                >
                </app-text-field>
              </app-col>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_dire"
                  type="text"
                  v-model="cru_dire"
                >
                </app-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_accounting_office"
                  type="text"
                  v-model="cru_accounting_office"
                >
                </app-text-field>
              </app-col>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_management_body"
                  type="text"
                  v-model="cru_management_body"
                >
                </app-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_processing_unit"
                  type="text"
                  v-model="cru_processing_unit"
                >
                </app-text-field>
              </app-col>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_proposing_body"
                  type="text"
                  v-model="cru_proposing_body"
                >
                </app-text-field>
              </app-col>
            </app-row>
          </template>
        </v-card-text>
        <v-card-actions class="pr-8">
          <v-spacer></v-spacer>
          <app-btn outlined @click="showAdditionalInfo=false">Cancelar</app-btn>
          <app-btn 
            color="primary"
            @click="updateWithAdditionalInfo"
          >
            Guardar
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CreationObject from '../components/CreationObject.vue'
import AppAutocomplete from '@/components/layout/AppAutocomplete.vue';
import AppDocTextField from "@/components/layout/AppDocTextField.vue";
import AppCreationObjectSectionCard from '@/components/layout/AppCreationObjectSectionCard.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppCombobox from '@/components/layout/AppCombobox.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import { mapState, mapGetters, mapActions } from "vuex"
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";
import { validateAccount } from "../utils/account_validation"
import DetailReferenceAccounts from '../components/DetailReferenceAccounts.vue'
import DetailReferenceSimple from '../components/DetailReferenceSimple.vue'
import { client, query_dispatcher } from "@/api/client";
import { AutocompleteCompanyData } from '@/modules/companies/application/AutocompleteCompanyData';
import MessagePopup from '@/components/MessagePopup.vue';
import { WorkflowTemplatesQuery } from "@/modules/document/application/WorkflowTemplatesQuery";
import { GetFiscalLocationInfoQuery } from "@/modules/invoices/app/GetFiscalLocationInfoQuery";
import AccountPrefixValidator from '../components/AccountPrefixValidator.vue';
import { showActivitiesSage200 as showActivitiesSage200Helper } from "@/store/modules/documents";
import { boolean } from 'mathjs';
import { PaymentMethodAPI } from "@/modules/company/infra/PaymentMethodAPI";
import { RevisoApi } from "@/modules/company/infra/RevisoApi";

export default {
  components: {
    AppAutocomplete,
    AppCombobox,
    AppDocTextField,
    AppCreationObjectSectionCard,
    AppTextField,
    AppSelect,
    AppRow,
    AppCol,
    AppBtn,
    CreationObject,
    DetailReferenceAccounts,
    DetailReferenceSimple,
    MessagePopup,
    AutocompleteCompanyData,
    AccountPrefixValidator
  },
  props: {
    supplier: {
      type: Number | String,
    },
    name: {
      type: String,
    },
    nif: {
      type: String,
    },
    isInModal: {
      type: Boolean,
      default: false,
    },
    document_id: {
      type: [String, Number],
      required: false,
      default: null
    },
  },
  data() {
    return {
      objectType: "Supplier",
      url: "suppliers/",
      areParamsChanged: false,
      decimal_separator_choices:[{value:null,text:'Funcionamiento por defecto'},{value:',',text:'Coma'}, {value:'.',text:'Punto'}],  
      account_types: [
        { text: '4000 - Proveedores', value: '4000?' }, 
        { text: '4100 - Acreedores', value: '4100?' },
      ],
      duplicate_message:'',
      currentTab: 'data',
      showAutocompletePupup: false,
      resolvePopupPromise:undefined,
      company_data:undefined,
      showDataNotFoundMessage: false,
      iva_values: [
        {text:'IVA 21%',value:'vat_21'},
        {text:'IVA 12%',value:'vat_12'},
        {text:'IVA 10.5%',value:'vat_10_5'},
        {text:'IVA 10%',value:'vat_10'},
        {text:'IVA 4%',value:'vat_4'}
      ],
      igic_values: [
        {text:'IGIC 1%',value:'igic_1'},
        {text:'IGIC 3%',value:'igic_3'},
        {text: 'IGIC 5%',value:'igic_5'},
        {text:'IGIC 7%',value:'igic_7'},
        {text:'IGIC 9.5%',value:'igic_95'},
        {text:'IGIC 15%',value:'igic_15'},
        {text:'IGIC 20%',value:'igic_20'}
      ],
      intra_values: [
        {text:'IVA 21%',value:'vat_21'}, {text:'IVA 12%',value:'vat_12'}, {text:'IVA 10.5%',value:'vat_10_5'},
        {text:'IVA 10%',value:'vat_10'}, {text:'IVA 4%',value:'vat_4'}, {text:'IVA 0%',value:'vat_0'},
        {text:'IGIC 20%',value:'igic_20'}, {text:'IGIC 15%',value:'igic_15'}, {text:'IGIC 9.5%',value:'igic_95'},
        {text:'IGIC 7%',value:'igic_7'}, {text:'IGIC 5%',value:'igic_5'}, {text:'IGIC 3%',value:'igic_3'}, {text:'IGIC 1%',value:'igic_1'},
        {text:'IGIC 0%',value:'igic_0'},
      ],
      showAdditionalInfo: false,
      workflowOptions:[{'name':'Sin workflow', 'id':null}],
      fiscal_locations: undefined,
      hasEInvoiceContract: false,
      currentText: '',
      is_payment_automatic_active: false,
      payment_methods: [],
      payment_account: null,
      paymentMethodAPI: null,
      reviso_api: null,
      group_accounts_in_reviso: [],
    };
  },
  methods: {
    onAccountChange(textUpdated) {
      this.currentText = textUpdated
    },
    ...mapActions(["setChoices", "setAutomaticPaymentAccountTypes"]),
    ...mapActions({
      get_identity_keys: 'cru/get_identity_keys',
      updateScreenValuesArray: "cru/updateScreenValuesArray",
    }),
    ...mapActions("cru", ['getAccounts']),
    upper(){
      this.cru_name = this.cru_name.toUpperCase()
    },
    updateRefExpensAccounts(val){
      this.updateScreenValuesArray({field:'ref_expens_accounts',value:val})
    },
    updateRefNoSujeta(val){
      this.updateScreenValuesArray({field:'refs_no_sujeta',value:val})
    },
    check_duplicates(val){
      if(val.length > 7 && val.length < 10 ){
        let cdb_id = this.currentCompany.id.toString()
        let own_id = this.supplier
        if (!this.supplier){
          own_id = '-1'
        }
        client.get('suppliers_with_same_cif/?companydb_id=' +cdb_id+ '&cif='+val+'&own_id='+own_id).then(response=>{
                        if(this.cru_cif == val){
                          this.duplicate_message = response.data.results
                        }
                    },
                    error=>{
                        console.debug(error)
                    })
      }
      else{
        this.duplicate_message = ''
      }
    },
    firstAppearance(list){
      for(let i in list){
        if(list[i]){
          return list[i]
        }
      }
      return ''
    },
    mycreated(id) {
      if (this.$router.currentRoute.name == 'document-detail') {
        this.$emit('createdObject', id);
      } else {
        this.$router.replace({ name: "supplier-update", params: {'supplier':id.id} });
      }
    },
    changeDescriptionSII() {
      if (this.cru_description_sii == 'descr_factura' && this.cru_fixed_value) {
        this.cru_fixed_value = '';
      }
    },
    change_boolean(value) {
      if (value != 'inversion_sujeto_pasivo_iva') {
        this.cru_inversion_sujeto_pasivo_iva = false;
      }
      if (value != 'inversion_sujeto_pasivo_igic') {
        this.cru_inversion_sujeto_pasivo_igic = false;
      }
      if (value != 'intracomunitario') {
        this.cru_intracomunitario = false;
      }
      if (value != 'extracomunitario') {
        this.cru_extracomunitario = false;
      }
      if (value != 'is_comerciante_minorista') {
        this.cru_is_comerciante_minorista = false;
      }
      if (value != 'no_sujeta') {
        this.cru_no_sujeta = false;
      }
      if (value != 'dry_0_percent') {
        this.cru_dry_0_percent = false;
      }
      this.areParamsChanged = true;
    },
    toggleIvaCheck() {
        if (this.selectedIvaCheck == this.lastSelectedIvaCheck) {
            this.selectedIvaCheck = undefined;
        }
        this.cru_gasto_iva_percent = 50;
    },
    showSuplidoAccount() {
      let show = false;
      if (this.feature_suplido_account && this.currentCompany && this.currentCompany.configuration && this.currentCompany.companydb_type.params) {
        show = ((!this.currentCompany.companydb_type.params.hasOwnProperty('hide')) || (this.currentCompany.companydb_type.params.hide && !this.currentCompany.companydb_type.params.hide.includes('suplido_account')));
      }
      return show      
    },
    getValues(params) {
      this.getAccounts(params).then(() => {});
    },
    resetItems(params) {
      this.accounts = params;
    },
    isNotDesgloseDeCuentas() {
      return this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.type == 'invoice' && 
      this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.hasOwnProperty("desglose_de_cuentas") && 
      !this.currentCompany.companydb_type.params.desglose_de_cuentas;
    },
    showNotFoundMessage() {
      this.showDataNotFoundMessage = true
    },
    confirm(company_data){
      this.showAutocompletePupup = true;
      this.company_data = company_data.data
      return new Promise((resolve,reject)=>{
        this.resolvePopupPromise = resolve
      })
    },
    confirmCompanyData(res){
      this.showAutocompletePupup = false;
      this.resolvePopupPromise(res)
    },
    async autocompleteSupplierData() {
      try {
        await new AutocompleteCompanyData(query_dispatcher,this).run(this.cru_cif)
      } catch(error) {
        console.error('Error autocomplete supplier data:', error);
      }
    },
    updateWithAdditionalInfo() {
      if (this.cru_type == 'fisica') {
        this.cru_name = `${this.cru_first_surname} ${this.cru_second_surname}, ${this.cru_first_name}`
      } else if (this.cru_type == 'juridica') {
        this.cru_name = this.cru_alias
      }
      this.showAdditionalInfo = false
    },
    hasMasterPermission(master) {
      return this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.show && 
      this.currentCompany.companydb_type.params.show.includes(master);
    },
    showActivitiesSage200() {
      return showActivitiesSage200Helper(
        this.currentCompany,
        this.userData
      );
    },
    onAutomaticPaymentChange(){
      if(this.cru_automatic_payment_account == 'na'){
        this.cru_payment_method_id = this.currentCompany.payment_method_id_supplier
        this.onPaymentMethodChange()
        //this.cru_payment_account = this.currentCompany.cuenta_cartera_supplier
      }else if(this.cru_automatic_payment_account != 'y'){
        this.cru_payment_method_id = ''
        this.cru_cartera = ''
        //this.cru_payment_account = ''
      }
    },
    onPaymentMethodChange(){
      let payment_methods = this.payment_methods.filter(payment_method => payment_method.payment_method_id == this.cru_payment_method_id)
      let external_id = ''
      if (payment_methods.length > 0){
          external_id = payment_methods[0].external_id
      }
      this.cru_cartera = external_id
    },
    isDisabledPaymentMethod(){
      return this.cru_automatic_payment_account && this.cru_automatic_payment_account != 'y'
    },
    isDisabledAutomaticPayment(){
      return this.currentCompany && this.currentCompany.automatic_payment_account && this.currentCompany.automatic_payment_account == 'n'
    },
    async setAutomaticPayment(){
      if(this.currentCompany && this.currentCompany.id){
        if(this.cru_automatic_payment_account && this.cru_automatic_payment_account == "na" && this.currentCompany && this.currentCompany.automatic_payment_account && this.currentCompany.automatic_payment_account == 'y'){
          //this.cru_automatic_payment_account = this.currentCompany.automatic_payment_account
          if(this.cru_payment_method_id == '' && this.currentCompany.cartera_supplier){
            this.cru_payment_method_id = this.currentCompany.payment_method_id_supplier
            this.cru_cartera = this.currentCompany.cartera_supplier
          }
          // if(this.cru_payment_account == '' && this.currentCompany.cuenta_cartera_supplier){
          //   this.cru_payment_account = this.currentCompany.cuenta_cartera_supplier
          // }
        }
      }
    },
    async getPaymentMethods(){
      this.paymentMethodAPI = new PaymentMethodAPI()
      let args = { companydb_id: this.currentCompany.id }
      this.payment_methods = await this.paymentMethodAPI.getPaymentMethodsByCompanyDB(args)
    },
    async onRevisoGroupChange(selectedValue) {
      if (!selectedValue) {
        this.cru_credit_account = '';
        return;
      }
      const prefix = selectedValue.toString();
      try {
        const result = await client.get(`get_next_account/${this.currentCompany.id}/${prefix}/`);
        this.cru_credit_account = result.data.next_account;
      } catch (error) {
        console.error('Error getting next available account:', error);
      }
    },
    async getGroupAccountsInReviso(){
      this.reviso_api = new RevisoApi()
      let args = { companydb_id: this.currentCompany.id, path: "supplier-groups" }
      this.group_accounts_in_reviso = await this.reviso_api.getAccountsFromThirdsGroupsInReviso(args) || []
    }
  },
  created() {
    this.actualScreen = "supplierScreenValues";
    this.selectedIvaCheck = undefined;
    this.cru_supplierScreenValues = {
      'inversion_sujeto_pasivo_iva': false,
      'inversion_sujeto_pasivo_igic': false,
      'iva_igic_no_deducible': false,
      'gasto_iva_parcial': false,
      'iva_parcial': false,
      'intracomunitario': false,
      'extracomunitario': false,
      'no_sujeta': false,
      'bien_inversion': false,
      'have_serie': false,
      'criterio_de_caja': false,
      'is_comerciante_minorista': false,
      'series': [],
      'ignore_cif_validation': false,
      'data': {
        'auto_account': false
      }
    };
    this.cru_errors_supplierScreenValues = {};
    this.get_identity_keys();
    this.accounts = [];
    if(this.feature_bien_inversion){
      this.account_types=[
        { text: '173 - Proveedores de inmovilizado a largo plazo' ,value: '173?' },
        { text: '4000 - Proveedores', value: '4000?' }, 
        { text: '4100 - Acreedores', value: '4100?' },
        { text: '523 - Proveedores de inmovilizado a corto plazo' ,value: '523?' },
      ]
    }
  },
  async mounted(){
    await this.getGroupAccountsInReviso()
    new GetFiscalLocationInfoQuery(query_dispatcher, this).run();
    await new WorkflowTemplatesQuery(query_dispatcher, this).run();
    if (this.currentCompany && this.userData) {
      let res = await query_dispatcher.dispatch('check.user.has.active.envoice.contract', { user_id: this.userData.id, company_id: this.currentCompany.id })
      this.hasEInvoiceContract = res['company']
    }
    await this.getPaymentMethods() 
    await this.setAutomaticPayment()
  },
  computed:{
    toggleAutoAccount: {
          get() {
            return this.cru_data ? this.cru_data.auto_account : false
          },
          set(value) {
            if (this.cru_data) {
              this.$set(this.cru_data, 'auto_account', value)
            }
          }
        },
    ...mapState(['currentCompany']),
    ...mapGetters({
      getCountryByCode: 'countries/getCountryByCode', 
      getCountries: 'countries/getCountries',
      get_retention_types: 'get_retention_types',
      get_automatic_payment_account_types: 'get_automatic_payment_account_types',
      getExtracomunitarioLabel: 'cru/getExtracomunitarioLabel',
      got_feature: 'got_feature',
      userData: 'me/userData',
      getExpensType: 'getExpensType',
    }),
    ...mapState('cru',['screenValues']),
    ...mapFields(['automaticPaymentAccountTypes', 'activities', 'projects', 'channels', 'sections', 'delegations', 'departments', 'thirdTypeTypes']),
    ...mapFields('cru',['actualScreen','selectedIvaCheck', 'identity_keys', 'accounts']),
    ...mapFields('cru',vuexPrefix('cru_', [
      'type', 'cif', 'name', 'alias', 'first_name', 'first_surname', 'second_surname', 'dire', 'accounting_office', 'management_body', 'processing_unit', 'proposing_body',
      'reference', 'expens_accounts', 'expens_account_bien_inversion', 'ref_expens_accounts', 
      'credit_account', 'retention_type', 'fiscal_location', 'inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_iva_percent', 'dry_0_percent',
      'inversion_sujeto_pasivo_igic', 'inversion_sujeto_pasivo_igic_percent', 'gasto_iva_percent', 'iva_igic_no_deducible', 
      'intracomunitario', 'intracomunitario_percent', 'intracomunitario_type', 'extracomunitario', 'extracomunitario_type', 'no_sujeta', 'bien_inversion',
      'importaciones_percent', 'address', 'zip_code', 'city', 'province', 'country', 'email', 'website', 'phone', 'notes', 
      'review', 'automatic_payment_account', 'payment_method_id', 'cartera', 'payment_account', 'payment_method', 'identity_key', 'auto_fill_due_date',
      'cut_inv_num', 'num_chars_inv_num', 'chars_to_exclude', 'prorate', 'suplido_account', 'default_actividad', 
      'building_code', 'have_serie', 'series', 'decimal_separator','max_price','min_price','cadastral_reference','refs_no_sujeta',
      'criterio_de_caja', 'description_sii', 'fixed_value', 'exc_expense_account','iva_no_deducible_account',
      'gasto_no_deducible_account', 'default_project', 'default_channel', 'default_section', 'default_delegation', 'is_comerciante_minorista', 'is_comerciante_minorista_percent',
      'retention_professional_account', 'retention_rental_account', 'retention_transport_account', 'register_iva_igic_0', 'ignore_cif_validation',
      'default_expens_income_type', 'data', 'is_generic', 'default_department', 'supplier_group'
    ], 'screenValues.supplierScreenValues.')),
    ...mapFields('cru',vuexPrefix('cru_error_',[
      'type', 'cif', 'name', 'alias', 'reference', 'expens_accounts', 'expens_account_bien_inversion', 'ref_expens_accounts', 
      'credit_account', 'retention_type', 'fiscal_location', 'inversion_sujeto_pasivo_iva', 'inversion_sujeto_pasivo_iva_percent', 'dry_0_percent',
      'inversion_sujeto_pasivo_igic', 'inversion_sujeto_pasivo_igic_percent', 'gasto_iva_percent', 'iva_igic_no_deducible', 
      'intracomunitario', 'intracomunitario_percent', 'intracomunitario_type', 'extracomunitario', 'extracomunitario_type', 'no_sujeta', 'bien_inversion',
      'importaciones_percent', 'address', 'zip_code', 'city', 'province', 'country', 'email', 'website', 'phone', 'notes', 
      'review', 'automatic_payment_account', 'cartera', 'payment_account','payment_method', 'identity_key', 'auto_fill_due_date', 'max_price','min_price',
      'num_chars_inv_num', 'fixed_value', 'exc_expense_account','iva_no_deducible_account','gasto_no_deducible_account',
      'is_comerciante_minorista_percent', 'supplier_group'
    ],'screenErrors.supplierScreenValues.')),
    ...mapFields('cru', vuexPrefix('cru_errors_',['supplierScreenValues'],'screenErrors.')),
    ...mapFields('cru',vuexPrefix('cru_label_',[
      'type', 'cif', 'name', 'alias', 'first_name', 'first_surname', 'second_surname', 'dire', 'accounting_office', 'management_body', 'processing_unit', 'proposing_body',
      'reference', 'expens_accounts', 'expens_account_bien_inversion', 'ref_expens_accounts', 'credit_account', 
      'retention_type', 'fiscal_location', 'inversion_sujeto_pasivo_iva', 'percent', 'inversion_sujeto_pasivo_igic', 'iva_igic_no_deducible', 
      'gasto_iva_parcial', 'iva_parcial','gasto_iva_percent', 'intracomunitario','intracomunitario_type', 'extracomunitario', 'extracomunitario_type',
      'no_sujeta', 'dry_0_percent','bien_inversion', 'address', 'zip_code', 'city', 'province', 'country', 'email', 'website', 'phone', 'notes', 'review', 
      'automatic_payment_account', 'cartera', 'payment_account','payment_method', 'identity_key', 'auto_fill_due_date', 'cut_inv_num', 
      'num_chars_inv_num', 'chars_to_exclude', 'prorate', 'default_actividad', 'building_code', 'suplido_account',
      'have_serie', 'series', 'decimal_separator','max_price','min_price','cadastral_reference', 'criterio_de_caja',
      'description_sii', 'fixed_value', 'exc_expense_account','iva_no_deducible_account','gasto_no_deducible_account',
      'default_project', 'default_channel', 'default_section', 'default_delegation', 'is_comerciante_minorista', 'retention_professional_account', 'retention_rental_account',
      'retention_transport_account', 'register_iva_igic_0', 'ignore_cif_validation', 'expens_income_type', 'is_generic', 'default_department', 'auto_account', 'supplier_group'
    ],'inputLabels.')),
    ...mapFields('cru', vuexPrefix('cru_', ['supplierScreenValues']), 'screenValues.'),
    ...mapFields('me',vuexPrefix('',['feature_no_sujeta_reference','feature_payment_move',
      'feature_no_sujeta', 'feature_intra_type', 'feature_extra_type', 'feature_extracomunitario_type', 'feature_extracomunitario_percent', 'feature_bien_inversion', 'feature_gasto_iva_parcial',
      'feature_iva_deducible_parcialmente', 'feature_can_auto_fill_due_date', 'feature_identity_key', 'feature_supplier_reference',
      'feature_prorate', 'feature_suplido_account','feature_expens_accounts_reference','feature_actividad_str_field',
      'feature_building_code','feature_payment_method','feature_retention_accounts_agrario', 'feature_account_type_innuva',
      'feature_decimal_separator','feature_price_range','feature_cadastral_reference',
      'feature_criterio_de_caja', 'feature_capital_retention',
    ],'userData.available_features.')),
    ...mapFields('documents', ['isBienInversionChanged', 'areIvaChecksChanged']),
    ...mapState(['currentCompany']),
    ...mapFields('connector', {
      companydb_types: 'companydb_types',
    }),
    showRefAccountDetailLocal(){
      return this.feature_expens_accounts_reference && this.currentCompany && this.currentCompany.companydb_type.params && (!this.currentCompany.companydb_type.params.hide || (this.currentCompany.companydb_type.params.hide && !this.currentCompany.companydb_type.params.hide.includes('expense_account_reference')))
    },
    errorInRefAccounts(){
      return Object.keys(this.cru_errors_supplierScreenValues).includes('ref_expens_accounts')
    },
    autocompleteCountryItems: function() {
      return this.getCountries.map((country_code) => {
        let country = this.getCountryByCode(country_code);
        return {"text": country.name, "value": country.code}
      });
    },
    automaticPaymentAccountTypesItems: function() {
      return this.automaticPaymentAccountTypes;
    },
    retentionTypesItems: function() {
      return this.setChoices().then(() => {
        return this.get_retention_types;
      })   
    },
    hideBienInversionAccount: function(){
      return this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.hasOwnProperty('hide') && this.currentCompany.companydb_type.params.hide.includes('expens_account_bien_inversion')
    },
      // Comprobación de valor de cuenta correcto, mediante RegExp
    accountRules() {
      return [
        (v) => !v ||  validateAccount(v) || 'La cuenta debe contener únicamente dígitos'
      ]
    },
    first_ref_account(){
      return (this.cru_ref_expens_accounts.length == 0)
    },
    filtered_retention_types() {
      return this.get_retention_types.filter(element => {
        const isAgricultureOrLivestock = element.value === 'retention_agriculture_account' || element.value === 'retention_livestock_account';
        const isCapital = element.value === 'retention_capital_account';
        const isProfessionalStartActivity = element.value === 'retention_professional_start_act_account';
        const isTransport = element.value === 'retention_transport_account';

        if ((!this.currentCompany.iva_agrario_pesca || !this.feature_retention_accounts_agrario) && isAgricultureOrLivestock) {
          return false;
        }
        if (!this.got_feature('feature_capital_retention') && isCapital) {
          return false;
        }
        if (!this.got_feature('feature_retention_professional_start_activity') && isProfessionalStartActivity) {
          return false;
        }
        if (!this.got_feature('feature_retention_accounts_transport') && isTransport) {
          return false;
        }
        return true;
      });
    },
    isRegularSupplierAccountType() {
      // TODO: Refactorizar para quitar $store y pasar esto a un getter en la store
      const regularSupplierPrefixes = ['40', '41']
      const creditAccount = this.$store.state.cru.screenValues.supplierScreenValues.credit_account
      const creditAccountPrefix = creditAccount ? creditAccount.slice(0,2) : null

      return regularSupplierPrefixes.includes(creditAccountPrefix)
    },

    refAccountsStyle() {
      if (this.$vuetify.breakpoint.xs) {
        return 'margin-top:-15% !important'
      }

      if (this.$vuetify.breakpoint.xl) {
        return 'margin-top: -3% !important'
      }

      return 'margin-top:-4% !important'
    },

  },
  watch: {
    selectedIvaCheck() {
        setTimeout(() => {
            this.lastSelectedIvaCheck = this.selectedIvaCheck;
        })
    },
    // 'currentCompany.automatic_payment_account': {
    //   handler(newVal) {
    //     if(this.cru_automatic_payment_account == "na"){
    //       this.cru_automatic_payment_account = newVal
    //     }
    //   },
    // },
    'currentCompany.cartera_supplier': {
      handler(newVal) {
        if(this.cru_automatic_payment_account == "na"){
          this.cru_automatic_payment_account = newVal
        }
      },
    },
    'currentCompany.cartera_customer': {
      handler(newVal) {
        if(this.cru_automatic_payment_account == "na"){
          this.cru_automatic_payment_account = newVal
        }
      },
    },
  },
};
</script>

<style scoped>
  .title-tabs {
    padding-bottom: 0px;
  }
  .items-tabs {
    margin-top: 0px !important;
  }
  ::v-deep .v-tabs-bar__content {
      background: #F8F8FA;
  }
  .v-tab {
      text-transform: capitalize !important;
      font-weight: 400;
      font-size: 18px;
  }
  .vm--modal {
  background-color: transparent !important;
  box-shadow: none !important;
  }
  .btn-create {
    font-size: 1.25rem; 
  }
  .checkbox-col {
    display: flex;
    flex-direction: column;
  }

  .col-check-btn {
    align-items: center;
    display: flex;
    gap: 8px;
  }
</style>
<style lang="scss" scoped>
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
  .modal-container {
    padding: 0px !important;
  }

</style>